exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module[data-v-c675fcc4]{margin-bottom:9px;padding:10px;background-color:#f1f1f1;display:-ms-grid;display:grid;-ms-grid-columns:256px 1fr;grid-template-columns:256px 1fr;column-gap:22px;row-gap:22px}@media only screen and (max-width:40em){.module[data-v-c675fcc4]{-ms-grid-columns:1fr;grid-template-columns:1fr}}.module__title[data-v-c675fcc4]{font-size:14px;font-family:inherit;color:#313131}.module__list[data-v-c675fcc4]{margin-bottom:6px;list-style-position:inside}.module__list[data-v-c675fcc4]:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c675fcc4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/tabs/modules/components/module/Module.vue
// module id = dab80e110bd4863477d9
// module chunks = 5